module.exports = __webpack_public_path__ + "static/media/medicine.6a72f038.svg";